.groups {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-lg);
}

.group {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
}

.groupTitle {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.measurementRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--mantine-spacing-xl);
}
